<template>
  <div id="home-page">
    <loading-component-s2 v-if="isLoading" />
    <div class="banners-section">
      <swiper class="swiper d-none d-lg-block" :options="bannersOptions">
        <swiper-slide v-for="(b, bdInx) in bannersDesktop" :key="'bdInx-'+bdInx">
          <a class="box-image placed-backg" v-bind:style="{ backgroundImage: 'url('+ b.image +')' }" :href="b.url">
            <img src="public/images/pages/home/banner.png" class="img-fluid" />
          </a>
        </swiper-slide>
        
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>

      <swiper class="swiper d-lg-none" :options="bannersOptions">
        <swiper-slide v-for="(banner, bmInx) in bannersMovil" :key="'bmInx-'+bmInx">
          <a class="box-image placed-backg" v-bind:style="{ backgroundImage: 'url('+ banner.image +')' }" :href="banner.url">
            <img src="public/images/pages/home/banner-m.png" class="img-fluid" />
          </a>
        </swiper-slide>
        
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <!-- <section  class="home-banners position-relative overflow-hidden">
      <div class="banner-bg position-absolute">
        <img src="public/images/pages/home/engine-piston-mechanical-part.jpg" alt="" class="banner-img" />
        <div class="banner-overlay position-absolute"></div>
      </div>

      <div class="container position-relative py-5 py-md-5 py-lg-5">
        <div class="row main-row">
          <div class="col-12 col-lg-8">
            <div class="d-flex align-items-center mb-4">
              <span v-for="i in 5" :key="i" class="stars">
                <i class="fa-solid fa-star mr-1"></i>
              </span>
              <span class="ml-2 trusted-text font-weight-bold">Trusted Quality</span>
            </div>

            <h1 class="banner-title font-weight-bold mb-4 text-white">
              Diesel Engine Components
            </h1>

            <p class="banner-subtitle mb-4 text-white">
              OEM-quality cylinder heads, camshafts, gaskets, and more for Cummins, CAT, Volvo, Detroit, and leading
              brands. Fast shipping across the USA.
            </p>

            <div class="d-flex flex-column flex-sm-row banner-buttons">
              <router-link
                to="/products"
                class="btn btn-lg btn-accent font-weight-bold mr-sm-3 mb-3 mb-sm-0"
              >
                Shop All Parts
              </router-link>
              <router-link
                to="/contacto"
                class="btn btn-lg btn-outline-light"
              >
                Request Quote
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <section id="featured-products" class="py-5 py-md-5 py-lg-5">
      <div class="container">
        <div class="text-center mb-5">
          <h2 class="section-title font-weight-bold mb-3">Featured Products</h2>
          <p class="section-subtitle text-muted mx-auto">
            Top-quality engine components trusted by mechanics and fleet managers nationwide
          </p>
        </div>

        <div class="row">
          <div
            v-for="product in products"
            :key="product.id"
            class="col-12 col-sm-6 col-lg-4 mb-4 box-product-s1"
          >
            <router-link
              :to="'/product/'+$root._converToURL(product.name, product.id)"
              class="text-decoration-none text-dark"
            >
              <div class="card h-100 sale-product-card shadow-sm">
                <div class="position-relative overflow-hidden sale-product-img-wrap">
                  <img
                    src="public/images/pages/products/product.png"
                    class="card-img-top sale-product-img placed-backg"
                    :style="{ backgroundImage: 'url('+ (product.image ? product.image : 'public/images/pages/products/placeholder.svg') +')' }"
                  />
                  <!-- <span class="badge badge-danger position-absolute sale-discount-badge">
                    -{{ $root.getPercentDiscount(product.price, product.price_offer) }}%
                  </span> -->
                  <span
                    v-if="product.inStock"
                    class="badge badge-accent position-absolute sale-stock-badge"
                  >
                    In stock
                  </span>
                  <!-- <span class="badge badge-danger position-absolute sale-stock-badge" v-else>Agotado</span> -->
                </div>
                <div class="card-body">
                  <div class="d-flex align-items-center mb-2">
                    <span class="text-muted small font-weight-medium mr-2" v-if="product.brand">{{ product.brand }}</span>
                    <span class="text-muted small mr-2" v-if="product.category">•</span>
                    <span class="text-muted small" v-if="product.category">{{ product.category }}</span>
                  </div>
                  <h3 class="card-title font-weight-semibold mb-2 sale-product-name">
                    {{ product.name }}
                  </h3>
                  <div class="d-flex align-items-baseline flex-wrap mt-3" v-if="$root.logged && product.distributor">
                    <h6 class="title-distributor"><i class="fa-regular fa-box mr-1 ic"></i> Distributor price</h6>
                    <span class="h4 font-weight-bold text-danger mr-1">
                      ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.distributor_unit_price) }}
                    </span>
                    <span class="usd text-danger">USD</span>
                    <span class="small text-muted w-100">1 piece</span>
                    <p
                      class="small wholesale-distributor mb-0 w-100"
                      v-if="product.wholesale_price && product.wholesale_quantity"
                    >
                      Wholesale: ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.wholesale_price) }} USD from {{ product.wholesale_quantity }} {{ product.wholesale_quantity === 1 ? 'piece' : 'pieces' }}
                    </p>
                  </div>
                  <div class="d-flex align-items-baseline flex-wrap mt-3" v-else-if="$root.logged">
                    <span class="h4 font-weight-bold mr-1" v-if="!product.price_offer">
                      ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}
                    </span>
                    <span class="h4 font-weight-bold text-danger mr-1" v-if="product.price_offer">
                      ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price_offer) }}
                    </span>
                    <span class="usd" :class="{ 'text-danger': product.price_offer }">USD</span>
                  </div>
                  <p class="small mt-1 mb-0 sku">{{ product.sku }}</p>
                </div>
                <div class="card-footer bg-white border-top">
                  <a class="btn btn-accent btn-block" to="">
                    READ
                    <!-- {{ product.inStock ? 'Add to cart' : 'Out of stock' }} -->
                  </a>
                </div>
              </div>
            </router-link>
          </div>

        </div>

        <div class="text-center mt-5">
          <router-link to="/products?k=&c=&b=&s=name&page=1" class="btn btn-outline-secondary btn-lg">
            View All Products
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: true,
      bannersDesktop: [],
      bannersMovil: [],
      products: [
        // {
        //   id: 'DEC3064291',
        //   name: 'Cummins N14 Plus Electric/Mechanical Crankshaft Luther',
        //   brand: 'Cummins',
        //   category: 'Crankshaft',
        //   originalPrice: 1249.99,
        //   price: 999.99,
        //   discount: 20,
        //   image: 'public/images/pages/products/crankshaft-engine-part.jpg',
        //   inStock: true,
        // },
      ],

      // == Carousel options ==
      bannersOptions: {
        loop: true,
        effect: 'fade',
        speed: 700,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
      // == ==
    }
  },

  methods: {
    gethome() {
      this.isLoading = true;
      axios.get('/api/home').then(response => {        
        this.bannersDesktop = response.data.banners.desktop;
        this.bannersMovil = response.data.banners.movil;
        this.products = response.data.products;
        setTimeout(() => {
          this.isLoading = false;
        }, 400);
      });
    },
  },

  mounted() {
    this.gethome();
  },
}
</script>
